// Mock €/m² monthly rent reference data (indicative, demo only)
export const locations = [
  { value: "75001", label: "Paris 1er — Louvre", price: 34 },
  { value: "75002", label: "Paris 2e — Bourse", price: 33 },
  { value: "75003", label: "Paris 3e — Temple", price: 34 },
  { value: "75004", label: "Paris 4e — Hôtel-de-Ville", price: 35 },
  { value: "75005", label: "Paris 5e — Panthéon", price: 33 },
  { value: "75006", label: "Paris 6e — Luxembourg", price: 37 },
  { value: "75007", label: "Paris 7e — Palais-Bourbon", price: 36 },
  { value: "75008", label: "Paris 8e — Élysée", price: 35 },
  { value: "75009", label: "Paris 9e — Opéra", price: 32 },
  { value: "75010", label: "Paris 10e — Entrepôt", price: 30 },
  { value: "75011", label: "Paris 11e — Popincourt", price: 30 },
  { value: "75012", label: "Paris 12e — Reuilly", price: 28 },
  { value: "75013", label: "Paris 13e — Gobelins", price: 28 },
  { value: "75014", label: "Paris 14e — Observatoire", price: 30 },
  { value: "75015", label: "Paris 15e — Vaugirard", price: 30 },
  { value: "75016", label: "Paris 16e — Passy", price: 31 },
  { value: "75017", label: "Paris 17e — Batignolles", price: 31 },
  { value: "75018", label: "Paris 18e — Butte-Montmartre", price: 29 },
  { value: "75019", label: "Paris 19e — Buttes-Chaumont", price: 27 },
  { value: "75020", label: "Paris 20e — Ménilmontant", price: 28 },
  { value: "neuilly", label: "Neuilly-sur-Seine (92)", price: 30 },
  { value: "levallois", label: "Levallois-Perret (92)", price: 28 },
  { value: "boulogne", label: "Boulogne-Billancourt (92)", price: 27 },
  { value: "vincennes", label: "Vincennes (94)", price: 26 },
  { value: "montreuil", label: "Montreuil (93)", price: 24 },
  { value: "autre", label: "Autre — petite couronne", price: 22 },
];

export const propertyTypes = [
  { value: "studio", label: "Studio", factor: 1.1 },
  { value: "t2", label: "2 pièces", factor: 1.03 },
  { value: "t3", label: "3 pièces", factor: 1.0 },
  { value: "t4", label: "4 pièces et +", factor: 0.95 },
];

export const conditions = [
  { value: "renover", label: "À rénover", factor: 0.9 },
  { value: "correct", label: "État correct", factor: 1.0 },
  { value: "neuf", label: "Refait à neuf", factor: 1.09 },
];

// Fee rates (already divided by two vs. original)
export const fees = {
  initial: 0.036,
  prestige: 0.042,
  gli: 0.021,
};

export function estimateRent({ location, type, condition, surface, furnished }) {
  const loc = locations.find((l) => l.value === location);
  const t = propertyTypes.find((p) => p.value === type);
  const c = conditions.find((x) => x.value === condition);
  if (!loc || !t || !c || !surface || surface <= 0) return null;

  // Small surfaces command a higher €/m²
  let surfaceFactor = 1;
  if (surface < 20) surfaceFactor = 1.15;
  else if (surface < 35) surfaceFactor = 1.07;
  else if (surface > 90) surfaceFactor = 0.9;
  else if (surface > 65) surfaceFactor = 0.95;

  const furnishedFactor = furnished ? 1.09 : 1;

  const raw =
    surface * loc.price * t.factor * c.factor * surfaceFactor * furnishedFactor;

  const monthly = Math.round(raw / 10) * 10;
  const low = Math.round((monthly * 0.93) / 10) * 10;
  const high = Math.round((monthly * 1.07) / 10) * 10;

  return {
    monthly,
    low,
    high,
    perM2: Math.round(monthly / surface),
    feesInitial: Math.round(monthly * fees.initial),
    feesPrestige: Math.round(monthly * fees.prestige),
    gli: Math.round(monthly * fees.gli),
  };
}
